import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule, ExcelModule } from '@progress/kendo-angular-grid';
import { AutoCompleteModule, MultiSelectModule, ComboBoxModule, DropDownListModule, } from '@progress/kendo-angular-dropdowns';
import { SwitchModule, NumericTextBoxModule } from '@progress/kendo-angular-inputs';
import { ButtonGroupModule, ButtonsModule } from '@progress/kendo-angular-buttons';

import { DataGridComponent } from './data-grid.component';
import { ColumnTemplatePipe } from './data-grid.pipe';
import { ConfigurationComponent } from './configuration/configuration.component';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { ConfigurationService } from './configuration/configuration.service';
import { RouterModule } from '@angular/router';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DateRangeFilterComponent } from './date-range-filter.component';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ButtonGroupModule,
        ButtonsModule,
        ReactiveFormsModule,
        GridModule,
        ExcelModule,
        SwitchModule,
        AutoCompleteModule,
        MultiSelectModule,
        ComboBoxModule,
        DropDownListModule,
        NumericTextBoxModule,
        MatTooltipModule,
        DialogModule,
        RouterModule,
        DateInputsModule,
    ],
    declarations: [
        DataGridComponent,
        ConfigurationComponent,
        DateRangeFilterComponent,
        ColumnTemplatePipe
    ],
    exports: [
        DataGridComponent,
        ColumnTemplatePipe
    ],
    providers: [
        ConfigurationService,
    ]
})
export class DataGridModule { }
